import { setToken, setAccountId } from './auth'

// 用来判断是安卓设备还是IOS设备
export function getPlatform() {
  var u = navigator.userAgent
  var ua = navigator.userAgent.toLowerCase()
  if (u.indexOf('guider-ios') > -1) { // ios
    return 'ios'
  } else if (ua.match(/MicroMessenger/i) === 'micromessenger') {
    return 'weixin'
  } else if (u.indexOf('guider-android') > -1) {
    return 'android'
  } else {
    return 'web'
  }
}

// 调用app方法
export function appCall(fn, data) {
  const platform = getPlatform()
  if (platform === 'ios') {
    window.webkit.messageHandlers[fn].postMessage(data)
  } else if (platform === 'android') {
    window.Android[fn](data)
  }
}

export const autoAppLogin = new Promise(function(resolve, reject) {
  if (getPlatform() === 'web' || getPlatform() === 'weixin') {
    resolve()
    return false
  } else if (getPlatform() === 'ios') {
    window.setUserInfo = function(data) {
      const { token, accountId } = data
      setToken(token)
      setAccountId(accountId)
      resolve(token)
    }
    window.webkit.messageHandlers.getUserInfo.postMessage({ 'callback': 'setUserInfo' })
  } else if (getPlatform() === 'android') {
    window.setUserInfoLogin = function(data) {
      const { token, accountId } = data
      setToken(token)
      setAccountId(accountId)
      resolve(token)
    }
    window.Android.getUserInfo('setUserInfoLogin')
  }
})

// 存储回调用户信息
export function setUserInfo(data) {
  const { token, accountId } = data
  setToken(token)
  setAccountId(accountId)
  this.$router.replace('/')
}

// 获取url的参数
export function UrlSearch() {
  let name
  let value
  let str = location.href
  let num = str.indexOf('?') // 取得整个地址栏
  str = str.substr(num + 1) // 取得所有参数 stringvar.substr(start [, length ]
  const arr = str.split('&') // 各个参数放到数组里
  for (let i = 0; i < arr.length; i++) {
    num = arr[i].indexOf('=')
    if (num > 0) {
      name = arr[i].substring(0, num)
      value = arr[i].substr(num + 1)
      // if (arr[0].substring(0, 4) === 'from') { // 如果连接里面带from
      // setTabbarShow('none')
      if (name === 'token') {
        // setToken(value)
        sessionStorage.setItem('GUIDERUSER.token', value)
      } else if (name === 'accountId') {
        // setAccountId(value)
        sessionStorage.setItem('GUIDERUSER.accountId', value)
      }
    }
    // }
  }
}
export const autoUrlToken = new Promise(function(resolve, reject) {
  resolve(UrlSearch())
})
